import { FC } from "react";
import { Facture } from "../../lib/interfaces/facture.interface";
import Title from "../ui/Title";
import { formatDate } from "../../lib/helpers/date_helpers";
import { AlertCircle } from "lucide-react";
import CommentPayerFactureDialog from "./CommentPayerFactureDialog";

interface Props {
  facture: Facture;
}

const FactureAPayerItem: FC<Props> = ({ facture: fac }) => {
  return (
    <div className="p-3 shadow rounded-lg bg-orange-100">
      <Title order={3} className="flex flex-row gap-3">
        <AlertCircle className="text-orange-600" /> Vous avez une facture en
        attente de paiement
      </Title>
      <div className="mt-3">
        La facture <strong>n°{fac.numero}</strong> datant du{" "}
        <strong>{formatDate(fac.date)}</strong> et d'un montant de{" "}
        <strong>{(fac.montant / 100).toFixed(2)}€</strong> est actuellement en
        attente de paiement.
        <br />
        Cette facture correspond à : <strong>{fac.description}</strong>
        <div className="my-3">
          <CommentPayerFactureDialog facture={fac} />
        </div>
      </div>
    </div>
  );
};

export default FactureAPayerItem;
